<template>
  <v-row>
    <v-col>
      <v-sheet
        outlined
        v-if="show_chat">
        <!-- Lateral con la lista de contactos -->
        <v-row>
          <v-col cols="12">

            <h3 class="title pa-4">Mis mensajes:</h3>
            <v-divider></v-divider>
            
            <v-list style="padding-top: 10px; border-right: 1px solid #E0E0E0;"  height="80vh" class="overflow-y-auto" >
              <!-- Aquí puedes iterar sobre tus contactos y mostrarlos en la lista -->
              <v-list-item v-for="contact in contacts" :key="contact.id" @click="getChat(contact.id)">
                  <v-list-item-avatar>
                    <v-img :src="require('@/assets/img/user.png')"></v-img>
                  </v-list-item-avatar>
  
                  <v-list-item-title>
                    {{ contact.name +' '+ contact.lastname }}
                  </v-list-item-title>

              </v-list-item>
            </v-list>
          </v-col>

        </v-row>
      </v-sheet>

      <v-sheet
        outlined
        class="d-flex align-center justify-center"
        min-height="70vh"
        v-if="!show_chat">
          <h3>Los mensajes se habilitarán una vez comenzada la JIJE.</h3>
      </v-sheet>

    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'Messages',
  data() {
    return {
      loading:true,
      show_chat:false,
      show_messages:false,
      selectedContact:null,
      message:null,
      receiver_id:null,
      messages: [],
      contacts: [],
    };
  },
  computed: {
    ...mapGetters([ 
        'user', 'edition'
    ])
  },
  mounted() {
    this.show_messages = true; // Muestra el v-sheet después de montar el componente
  },
  methods: {
    scroller(){
      this.$nextTick(() => {
        this.$vuetify.goTo(this.$refs.scrollContainer.scrollHeight, { duration: 0 });
      });
    },

    scrollToBottom() {
      this.$refs.scrollContainer.scrollTop = this.$refs.scrollContainer.scrollHeight;
    },

    isStartDateValid() {
      const startDate = this.edition.edition.start_date_public_access;
      const currentDate = new Date();
            
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Agrega un 0 al mes si es necesario
      const day = String(currentDate.getDate()).padStart(2, '0'); // Agrega un 0 al día si es necesario

      const formattedDate = `${year}-${month}-${day}`;
      this.show_chat = startDate <= formattedDate;
    },

    selectContact(contact) {
      this.show_messages = false
      this.selectedContact = contact.id;
      this.show_messages = true
    },

    async getChat(id){
      this.$router.push( { name: "chat",  params: { id: id }} )
    },

    async getMessages(){
      await axios.get('messages').then(response =>{
          this.messages = response.data.data.messages
          this.contacts = response.data.data.contacts
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
    },

    async sendMessage(){
      try {
        await axios.post('messages',{
          message: this.message, 
          receiver_id: this.receiver_id, 
          }).then(response =>{
            this.message = ''
            this.updateChat(this.receiver_id)
            this.scroller()
            console.log(response)
          })
        } catch (error) {
            this.message = ''
            this.dialog_message = false
            console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
        }
    },

    async updateChat(id){
      await axios.get('messages/'+id).then(response =>{
          this.messages = response.data.data.messages
        }).catch(error => {
          console.log(error);
        })
    }
  },

  created(){
      this.isStartDateValid()
      this.getMessages()
    },
};
</script>
<style scoped>
.scroll-container {
  max-height: 100%;
  overflow-y: auto;
}
.section-chat{
  height: 83%;
}
.section-message{
  height: 17%;
}
.speech-bubble {
  position: relative;
  background-color: #f1f1f1;
  border-radius: 10px;
  padding: 10px;
  margin: 10px;
  max-width: 300px;
}

.speech-bubble::before {
  content: '';
  position: absolute;
  border-style: solid;
  border-width: 10px;
  border-color: transparent transparent #f1f1f1 #f1f1f1;
  bottom: -20px;
  right: 0;
}
</style>
